import { createFileRoute } from '@tanstack/react-router';
import { LeadsListPage } from '../../../features/crm';
import { usePageTitle } from '../../../lib/hooks';

export const Route = createFileRoute('/_auth/crm/leads')({
  component: LeadsRoute,
});

function LeadsRoute() {
  usePageTitle('Leads');
  return <LeadsListPage />;
}
